import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { getDetailLabel } from '@/shared/copy/details';

export type CoverageFilesSortKey =
  | 'createdAt'
  | 'branchesPct'
  | 'fileName'
  | 'functionsPct'
  | 'linesPct'
  | 'sourceKey'
  | 'statementsPct';

export const coverageFilesTableDefinition: TableDefinition<CoverageFilesSortKey, 'unused'> =
  createTableDefinition({
    title: 'Coverage Files',
    searchAriaLabel: 'Search coverage files by file name',
    columns: [
      { field: 'fileName', label: 'File', mandatory: true, defaultVisible: true },
      { field: 'linesPct', label: 'Line Coverage', defaultVisible: true },
      { field: 'functionsPct', label: 'Function Coverage', defaultVisible: true },
      { field: 'branchesPct', label: 'Branch Coverage', defaultVisible: true },
      { field: 'statementsPct', label: 'Statement Coverage', defaultVisible: true },
      { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
      { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
    ],
    defaultSortKey: 'createdAt',
    defaultSortDirection: 'desc',
    sortOptions: [
      { key: 'createdAt', label: getDetailLabel('uploaded') },
      { key: 'fileName', label: 'File' },
      { key: 'linesPct', label: 'Line Coverage' },
      { key: 'functionsPct', label: 'Function Coverage' },
      { key: 'branchesPct', label: 'Branch Coverage' },
      { key: 'statementsPct', label: 'Statement Coverage' },
      { key: 'sourceKey', label: 'Source' },
    ],
    sortFieldMap: {
      fileName: 'fileName',
      linesPct: 'linesPct',
      functionsPct: 'functionsPct',
      branchesPct: 'branchesPct',
      statementsPct: 'statementsPct',
      sourceKey: 'sourceKey',
      createdAt: 'createdAt',
    },
    statusOptions: [],
  });
